export default "__VITE_ASSET__D3XkCaba__"